import { memo, ReactNode } from "react";
import { AccessDeniedBlock } from "@tecorien/mimic";
import { AuthorizationContextProvider as BaseAuthorizationContextProvider, GlobalLoaderRemover } from "@tecorien/mimic-v2";
import { useKeycloak } from "keycloak";
import { links } from "links";

export type AuthorizationContextProviderProps = {
  children: ReactNode | ReactNode[]
}

export const AuthorizationContextProvider = memo<AuthorizationContextProviderProps>(({ children }) => {
  return (
    <BaseAuthorizationContextProvider
      permissions={useKeycloak().roles}
      redirectUrl={links.accessDenied}
      accessDeniedStub={<GlobalLoaderRemover><AccessDeniedBlock /></GlobalLoaderRemover>}
    >
      {children}
    </BaseAuthorizationContextProvider>
  );
});

export default AuthorizationContextProvider;